import { getSeoPageByPath, normalizePath } from './seoPages';

// Only explicitly identified crawlers retain the static document. Unknown
// agents, mobile browsers and browser automation get the interactive UI.
const CRAWLER_AGENT = /Googlebot|Google-InspectionTool|bingbot|BingPreview|DuckDuckBot|Baiduspider|YandexBot|Applebot|Slurp|GPTBot|OAI-SearchBot|ChatGPT-User|ClaudeBot|Claude-SearchBot|Claude-User|anthropic-ai|PerplexityBot|Perplexity-User|facebookexternalhit|Facebot|meta-externalagent|Twitterbot|LinkedInBot|Slackbot|Discordbot|TelegramBot/i;

export const isKnownCrawler = (userAgent = '') => CRAWLER_AGENT.test(userAgent);

export function getStatsEntry(pathname, userAgent = '', prerenderedPath = '') {
  const page = getSeoPageByPath(pathname);
  if (!page || !page.statsEmbed) return { page: null, keepStatic: false };
  return {
    page,
    // Never leave a blank shell in development or on SPA fallback URLs.
    keepStatic: isKnownCrawler(userAgent) &&
      normalizePath(prerenderedPath) === normalizePath(page.path)
  };
}